module.exports = __webpack_public_path__ + "img/selected2-min.b64a8a16.png";